<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 flex justify-between">
                <h1 class="text-2xl font-bold">Voci di spesa predefinite</h1>

                <div class="flex flex-col w-1/4">
                    <Field :label-visible="false" @update:modelValue="lista.debounceSearch" v-model="lista.search"
                           placeholder="Cerca"></Field>
                </div>

                <NextButton component="router-link" :to="{name:'CreaVociSpesaBusinessUnitsIva'}"
                            class="py-1 px-3">
                    Nuovo
                </NextButton>
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                        <router-link
                            :to="{name:'DettaglioVociSpesaBusinessUnitsIva', params:{id:context.context.row.id}}"
                            class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>
            </div>
            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre voci.</div>
                </template>
            </InfiniteLoading>

            <div class="flex pt-3 justify-end">
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import businessUnitsManager from "@/api/BusinessUnits";
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Checkbox from "@/components/Checkbox.vue";
import Autocomplete from "@/setup/Autocomplete";
import userManager from "@/api/Users";
import draggable from 'vuedraggable'
import {mapGetters} from 'vuex';
import Lista from "@/setup/ListaCerca";
import progettiManager from "@/api/Progetti";
import voceSpesaBusinessUnitIvaManager from "@/api/VoceSpesaBusinessUnitIvaManager";
import Paginator from "@/components/Paginator.vue";

@Options({
    name: 'VociSpesaBusinessUnitsIva',
    components: {
        Paginator,
        Checkbox,
        MultiselectOption, NextButton,
        Loading,
        Field,
        NextTable,
        InfiniteLoading,
        draggable
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
    },
    computed: {
        ...mapGetters('buFieldModule', [
            'allField',
            'cellsDescriptor',
            'isCellAcquisto',
            'isCellVendita',
            'isCellRe',
            'isCellNe',
        ]),
    }
})
export default class BusinessUnitsDetail extends Vue {
    lista: any = setup(() => Lista(voceSpesaBusinessUnitIvaManager, this.cols));
    id!: number

    bu = {
        nome: '',
        id: 0,
        created_at: null,
        updated_at: null,
        label: '',
        show_crm: false,
        show_progetti: false,
        bu_father_id: null,
        field_default: '',
        PD1G_CODICE: '',
        controllore_user_id: null
    }
    esito = false
    response_message = ''
    errors = {}

    created() {
        this.lista.fetchData()
    }

    save() {

    }

    cols = [
        {
            name: 'Voce di spesa',
            prop: 'descrizione_voce_spesa',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Business unit',
            prop: 'descrizione_bu',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },

        {
            name: 'Iva di acquisto',
            prop: 'descrizione_iva_acquisto',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Iva di vendita',
            prop: 'descrizione_iva_vendita',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]

}

</script>


<style lang="scss">

</style>
